export const findCommunicationModeNameFromIndex = (communicationMode, communicationModeTemplates) => {
	if (!communicationMode || !communicationModeTemplates) {
		throw new TypeError('Please pass required parameters!!!');
	}
	return communicationModeTemplates.find(communicationModeTemplate => {
		return communicationModeTemplate.index == communicationMode;
	}).name;
};
